import '../css/Rules.css'
import {barRules, homeRules} from "../constants/Constants";


function Rules(props) {

    const rulesList = props.edition === 'bar' ? (
        <ul className={"rules-list"}>
            {[...barRules].map(rule => (
                <li key={rule} className={"rule"}>{rule}</li>
            ))}
        </ul>
    ) : (
        <ul className={"rules-list"}>
            {[...homeRules].map(rule => (
                <li key={rule} className={"rule"}>{rule}</li>
            ))}
        </ul>
    )
    return (
        <div className={"rules-body"}>
            <h1 className={"rules-heading"}>Rules</h1>
            {rulesList}
            <div className={"back-container"}>
                {props.back}
            </div>
        </div>
    )

}

export default Rules;